<script setup lang="ts">
import keycloak from '@/keycloak'
import { MutationTypes, type State } from '@/store/store_types'
import { computed, ref, watch } from 'vue'
import { useDisplay } from 'vuetify'
import { useStore } from 'vuex'
import ElevatedBlockBtn from '../ui-elements/buttons/ElevatedBlockBtn.vue'
import ElevatedBtn from '../ui-elements/buttons/ElevatedBtn.vue'
import OutlinedBlockBtn from '../ui-elements/buttons/OutlinedBlockBtn.vue'
import OutlinedBtn from '../ui-elements/buttons/OutlinedBtn.vue'
import AlertPopupWindowCopy from './AlertPopupWindow.vue'

const store = useStore<State>()

const activator = ref(false)

const displayFlag = computed(() => store.state.show_account_needed)
const doNotShowAgainFlag = computed(() => store.state.DSA_account_needed_warning)
const action = computed(() => store.state.returning_auth_action)
const actionDisplayStr = computed(() => {
  switch (action.value) {
    case 'add_location':
      return 'add a location'
    case 'connect_with_sales':
      return 'connect with our sales team'
    case 'edit_user':
      return 'edit your user account'
    case 'save_trip':
      return 'save your trip'
    default:
      return 'use this feature'
  }
})

watch(displayFlag, (value) => {
  if (value) {
    if (!doNotShowAgainFlag.value) activator.value = true
  } else {
    activator.value = false
  }
})

function close() {
  store.commit(MutationTypes.setShow_account_needed, false)
}

function toggleDoNotShowAgain(value: boolean) {
  store.commit(MutationTypes.setDSA_account_needed_warning, value)
}

function handleLogin() {
  const redirectUri =
    window.location.origin +
    '/#/login/' +
    new URLSearchParams(
      'location=' +
        (window.location.hash.includes('location=')
          ? window.location.hash.replace(/&location=.*/, '')
          : window.location.hash) +
        '&' +
        (action.value ? 'action=' + action.value + '&' : '') +
        window.location.search,
    ).toString()

  keycloak.login({
    redirectUri,
  })
}

const { mobile } = useDisplay()
</script>
<template>
  <AlertPopupWindowCopy
    :activator="activator"
    @close="close"
    @after-leave="() => {}"
    @do-not-show-again="
      () => {
        toggleDoNotShowAgain(true)
      }
    "
    @show-again="
      () => {
        toggleDoNotShowAgain(false)
      }
    "
  >
    <v-card flat :max-width="mobile ? undefined : '70%'">
      <v-card-title class="text-center pt-0 pb-8 font-weight-bold"> Account needed </v-card-title>
      <v-card-text class="text-center">
        You need a Power Trip account to {{ actionDisplayStr }}
      </v-card-text>
      <v-card-actions v-if="mobile" class="flex-column align-start justify-center pt-5">
        <ElevatedBlockBtn @click="handleLogin"> Create account or login </ElevatedBlockBtn>
        <OutlinedBlockBtn shape="box" @click="close"> Cancel </OutlinedBlockBtn>
      </v-card-actions>
      <v-card-actions v-else class="justify-center pt-5">
        <OutlinedBtn @click="close" class="mr-2"> Cancel </OutlinedBtn>
        <ElevatedBtn @click="handleLogin" class="ml-2"> Create account or login </ElevatedBtn>
      </v-card-actions>
    </v-card>
  </AlertPopupWindowCopy>
</template>
